module.exports = __webpack_public_path__ + "static/media/KMH_5205.c3ce1917.jpg";